export default __webpack_public_path__ + "static/210521_妲絲刷關活動熱更預告_sc-df81c8fd3a5495aa100056361d3fa1a6.webp";